import { useContext, useEffect, useState } from 'react'
import CustomPaper from '../../../containers/Paper'
import { StatisticsContext } from '../../../context/StatisticsContext'
import StatisticsService from '../../../services/StatisticsService'
import { Line } from 'react-chartjs-2'
import { CircularProgress } from '@mui/material'
import { statisticsColors } from '../StatisticsPage'
import { formatDaysToYearsAndMonths } from '../../../helpers/utils'

interface DataType {
    position: string
    days: number
}

const DaysToReachHierarchicalPosition = () => {
    const { startDate, endDate, carreer } = useContext(StatisticsContext)
    const [leadershipData, setLeadershipData] = useState<DataType>()
    const [managementData, setManagementData] = useState<DataType>()
    const [directiveData, setDirectiveData] = useState<DataType>()

    useEffect(() => {
        const service = new StatisticsService()
        service
            .getDaysToReachHierarchicalPosition('Liderazgo', carreer, startDate, endDate)
            .then((response) => {
                if (response.status !== 200) return
                setLeadershipData({ position: 'Liderazgo', days: response.data })
            })
        service
            .getDaysToReachHierarchicalPosition('Gerencial', carreer, startDate, endDate)
            .then((response) => {
                if (response.status !== 200) return
                setManagementData({ position: 'Liderazgo', days: response.data })
            })
        service
            .getDaysToReachHierarchicalPosition('Directivo', carreer, startDate, endDate)
            .then((response) => {
                if (response.status !== 200) return
                setDirectiveData({ position: 'Liderazgo', days: response.data })
            })
    }, [carreer, startDate, endDate])

    const getChartData = () => {
        return {
            labels: ['Liderazgo', 'Gerencial', 'Directivo'],
            datasets: [
                {
                    label: 'Tiempo medio para alcanzar el nivel jerárquico',
                    data: [
                        leadershipData?.days ?? 0,
                        managementData?.days ?? 0,
                        directiveData?.days ?? 0,
                    ],
                    backgroundColor: statisticsColors.background.slice(1),
                    borderColor: statisticsColors.border.slice(1),
                    borderWidth: 2,
                    pointRadius: 8,
                    pointHoverRadius: 12,
                },
            ],
        }
    }

    const options = {
        scales: {
            y: {
                beginAtZero: true,
            },
        },
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            tooltip: {
                callbacks: {
                    label(context: any) {
                        const value = formatDaysToYearsAndMonths(context.raw)
                        return `${value} (${context.raw} días)`
                    },
                },
            },
        },
    }

    return (
        <CustomPaper className="flex flex-col gap-2 h-full text-primary">
            <span className="text-lg font-semibold">
                Tiempo medio para llegar a puestos jerárquicos (en días)
            </span>
            <div className="flex-1 w-full h-full">
                {leadershipData && directiveData && managementData ? (
                    <Line
                        data={getChartData()}
                        options={options}
                    />
                ) : (
                    <div className="w-full h-full flex justify-center items-center">
                        <CircularProgress
                            className="m-2 md:m-5 text-primary"
                            size={64}
                        />
                    </div>
                )}
            </div>
        </CustomPaper>
    )
}

export default DaysToReachHierarchicalPosition
